<template>
  <main>
    <ErrorNotFound v-if="error.statusCode === 404" />
    <NuxtLayout v-else name="minimal">
      <ErrorServer :code="error.statusCode || 500" />
    </NuxtLayout>
  </main>
</template>

<script setup lang="ts">
import { MAX_AGE } from '~~/server/helpers'
import { buildFastlyCacheTags } from '~~/server/utils/cacheability'

type ErrorObject = {
  url?: string
  statusCode?: number
  statusMessage?: string
  message?: string
  stack?: string
}

const props = defineProps<{
  error: ErrorObject
}>()

if (import.meta.dev) {
  console.log(props.error)
}

useCDNHeaders((v) => {
  if (props.error.statusCode?.toString().startsWith('4')) {
    // Cache 404s using Drupal's 4xx response cache tag.
    v.addTags(buildFastlyCacheTags(['4xx-response'])).setNumeric(
      'maxAge',
      MAX_AGE.ONE_MINUTE,
    )
  } else {
    // All other errors should NOT be cached.
    v.private()
  }
})
</script>
